import React from 'react';

import { SuiContainer, SuiLabel } from '@splashthat/sui';

import { BUTTON_COLOR_LABEL, BUTTON_TEXT_LABEL } from '../../../../constants/formStyleLabels';
import { COLLAPSIBLE_CONTENT, COLLAPSIBLE_SECTION } from '../../../../constants/reusableClassNames';

import { BUTTON_QA } from '../../../../utils/qaIdConstants';
import ButtonAlignmentPanel from './ButtonAlignmentPanel';
import ButtonBackgroundPanel from './ButtonBackgroundPanel';
import ButtonBorderPanel from './ButtonBorderPanel';
import ButtonTextPanel from './ButtonTextPanel';

/** @var {Object} - section components and labels ordered. */
const SECTION_PANELS = [
    {
        panel: <ButtonBackgroundPanel />,
        label: BUTTON_COLOR_LABEL,
        qaId: 'buttonColor',
    },
    {
        panel: <ButtonTextPanel />,
        label: BUTTON_TEXT_LABEL,
        qaId: 'buttonText',
    },
    {
        panel: <ButtonBorderPanel />,
        qaId: 'border',
    },
    {
        panel: <ButtonAlignmentPanel />,
        qaId: 'buttonPosition',
    },
];

const FormStyleEditorButtonPanel = () => (
    <SuiContainer className={COLLAPSIBLE_CONTENT} data-qa={`${BUTTON_QA}--panel`}>
        {SECTION_PANELS.map(({ panel, label, qaId }, index) => (
            <SuiContainer key={index} className={COLLAPSIBLE_SECTION} data-qa={`${BUTTON_QA}--section-${qaId}`}>
                {label && <SuiLabel text={label} data-qa={`${BUTTON_QA}--label`} />}
                {panel}
            </SuiContainer>
        ))}
    </SuiContainer>
);

export default FormStyleEditorButtonPanel;
